import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { showLowConfig } from "./data";

export default function ShowLowPage() {
  return <CityPageTemplate config={showLowConfig} />;
}